import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ARROW_FOCUS_TRAP_ITEM_CLASS_NAME = 'ArrowFocusTrapItem';

export const ARROW_FOCUS_TRAP_ITEM_CLASS_SLOTS = ['root'] as const;

export type ArrowFocusTrapItemClassSlot =
	(typeof ARROW_FOCUS_TRAP_ITEM_CLASS_SLOTS)[number];

export interface ArrowFocusTrapItemClasses {
	root: string;
	focusActive: string;
	focusDisabled: string;
}

export type ArrowFocusTrapItemClassKey = keyof ArrowFocusTrapItemClasses;

export const getArrowFocusTrapItemUtilityClass = (slot: string) =>
	generateUtilityClass(ARROW_FOCUS_TRAP_ITEM_CLASS_NAME, slot);

export const arrowFocusTrapItemClasses: ArrowFocusTrapItemClasses =
	generateUtilityClasses(ARROW_FOCUS_TRAP_ITEM_CLASS_NAME, [
		'root',
		'focusActive',
		'focusDisabled',
	]);

export default arrowFocusTrapItemClasses;
